module.exports = __webpack_public_path__ + "img/Number=18.b8213f34.png";